import { useEffect, useState } from "react";
import OrderService from "../../../../../../service/OrderService";
import { EXTRAPAY_SUCCESS_CODE } from "../constants";
import { annotatePurchases } from "../extrapayPoints";

const useExtrapayPurchases = ({ cycle, ordersInCycle, enabled }) => {
  const [purchases, setPurchases] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    if (!enabled) return undefined;

    let cancelled = false;
    const orderService = new OrderService();
    const token = localStorage.getItem("__extraconomy_token");
    const username = localStorage.getItem("__extraconomy_username");

    const load = async () => {
      setIsLoading(true);
      setHasError(false);
      try {
        const response = await orderService.getPurchases(token, username);
        if (cancelled) return;
        if (response?.messageCode !== EXTRAPAY_SUCCESS_CODE) {
          setHasError(true);
          setPurchases([]);
          return;
        }
        setPurchases(annotatePurchases(response.result, cycle, ordersInCycle));
      } catch (error) {
        if (!cancelled) {
          setHasError(true);
          setPurchases([]);
        }
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [cycle, enabled, ordersInCycle]);

  return { purchases, isLoading, hasError };
};

export default useExtrapayPurchases;
